
// import React, { useState, useEffect } from "react";

// function Webcards() {
//   const features = [
//     {
//       title: "Fast Loading Websites",
//       description:
//         "Ensure users enjoy a seamless and fast browsing experience.",
//     },
//     {
//       title: "Scalable Solutions",
//       description:
//         "Websites built to grow alongside your business needs.",
//     },
//     {
//       title: "Creative Designs",
//       description:
//         "Stand out with aesthetically pleasing and user-friendly designs.",
//     },
//     {
//       title: "Cutting-Edge Technology",
//       description:
//         "Stay ahead with the latest tools and frameworks.",
//     },
//     {
//       title: "Top-notch Security",
//       description:
//         "Protect your website and users with secure web practices.",
//     },
   
//   ];

//   const [inView, setInView] = useState(false);

//   useEffect(() => {
//     const handleScroll = () => {
//       const topPosition = document.getElementById("features-section").getBoundingClientRect().top;
//       if (topPosition <= window.innerHeight * 0.75) {
//         setInView(true);
//       }
//     };

//     window.addEventListener("scroll", handleScroll);

//     // Cleanup the event listener on unmount
//     return () => {
//       window.removeEventListener("scroll", handleScroll);
//     };
//   }, []);

//   return (
//     <div
//       id="features-section"
//       style={{
//         ...styles.container,
//         backgroundImage: "url('/image/walp2.avif')", 
//         backgroundSize: "cover",
//         backgroundPosition: "center",
//       }}
//     >
//       <h2 style={styles.heading}>Benefits of Our Web Development Services</h2>
//       <div
//         style={{
//           ...styles.cardsContainer,
//           transform: inView ? "translateY(0)" : "translateY(50px)",
//           opacity: inView ? 1 : 0,
//           transition: "all 1s ease",
//         }}
//       >
//         {features.map((feature, index) => (
//           <div
//             key={index}
//             style={{
//               ...styles.card,
//               transform: inView
//                 ? "translateX(0)"
//                 : index % 2 === 0
//                 ? "translateX(-100px)"
//                 : "translateX(100px)",
//               opacity: inView ? 1 : 0,
//               transition: "all 0.8s ease",
//             }}
//           >
//             <h3 style={styles.cardTitle}>{feature.title}</h3>
//             <p style={styles.cardDescription}>{feature.description}</p>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// }

// const styles = {
//   container: {
//     padding: "80px 20px",
//     textAlign: "center",
//     fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
//     minHeight: "100vh",
//     position: "relative",
//   },
//   heading: {
//     fontSize: "2.5rem",
//     color: "black",
//     marginBottom: "40px",
//     fontWeight: "700",
//     position: "relative",
//     display: "inline-block",
//   },
//   cardsContainer: {
//     display: "grid",
//     gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
//     gap: "30px",
//     maxWidth: "1200px",
//     margin: "0 auto",
//     padding: "0 20px",
//   },
//   card: {
//     backgroundColor: "#ffffff",
//     border: "none",
//     padding: "30px",
//     borderRadius: "12px",
//     boxShadow: "0 10px 20px rgba(0, 0, 0, 0.08)",
//     transition: "all 0.3s ease-in-out",
//     cursor: "pointer",
//     position: "relative",
//     overflow: "hidden",
//     zIndex: "1",
//     ":hover": {
//       transform: "translateY(-10px)",
//       boxShadow: "0 15px 30px rgba(0, 0, 0, 0.12)",
//     },
//   },
//   cardTitle: {
//     fontSize: "1.5rem",
//     color: "#1e40af",
//     marginBottom: "15px",
//     fontWeight: "600",
//     position: "relative",
//     paddingBottom: "10px",
//     ":after": {
//       content: '""',
//       position: "absolute",
//       bottom: "0",
//       left: "0",
//       width: "50px",
//       height: "3px",
//       backgroundColor: "#3b82f6",
//       borderRadius: "3px",
//     },
//   },
//   cardDescription: {
//     fontSize: "1rem",
//     color: "#4b5563",
//     textAlign: "left",
//     lineHeight: "1.6",
//     marginTop: "15px",
//   },
// };

// // Add hover effects that can't be done in inline styles
// const styleTag = document.createElement("style");
// styleTag.innerHTML = `
//   .feature-card:hover {
//     transform: translateY(-10px);
//     box-shadow: 0 15px 30px rgba(0, 0, 0, 0.12);
//   }
//   .feature-card::before {
//     content: "";
//     position: absolute;
//     top: 0;
//     left: 0;
//     width: 100%;
//     height: 5px;
//     background-color: #3b82f6;
//     transform: scaleX(0);
//     transform-origin: left;
//     transition: transform 0.3s ease;
//     z-index: -1;
//   }
//   .feature-card:hover::before {
//     transform: scaleX(1);
//   }
//   .feature-card h3::after {
//     content: "";
//     position: absolute;
//     bottom: 0;
//     left: 0;
//     width: 50px;
//     height: 3px;
//     background-color: #3b82f6;
//     border-radius: 3px;
//   }
// `;
// document.head.appendChild(styleTag);

// export default Webcards;



import React from "react";
import { motion } from "framer-motion";

function Features() {
  const features = [
    {
      title: "Fast Loading Websites",
      description:
        "Ensure users enjoy a seamless and fast browsing experience.",
      color: "#1E40AF",
      animation: { x: -100, y: 0 }, // from left
    },
    {
      title: "Scalable Solutions",
      description:
        "Websites built to grow alongside your business needs.",
      color: "#2563EB",
      animation: { x: 100, y: 0 }, // from right
    },
    {
      title: "Creative Designs",
      description:
        "Stand out with aesthetically pleasing and user-friendly designs.",
      color: "#9333EA",
      animation: { x: 0, y: 100 }, // from bottom
    },
    {
      title: "Cutting-Edge Technology",
      description:
        "Stay ahead with the latest tools and frameworks.",
      color: "#059669",
      animation: { x: -100, y: 0 }, // from left
    },
    {
      title: "Top-notch Security",
      description:
        "Protect your website and users with secure web practices.",
      color: "#DC2626",
      animation: { x: 100, y: 0 }, // from right
    },
  ];

  const styles = {
    container: {
      padding: "60px 20px",
      textAlign: "center",
      background: "linear-gradient(to right, #e0f2fe, #f8fafc)",
      fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    },
    heading: {
      fontSize: "32px",
      marginBottom: "40px",
      fontWeight: "bold",
    },
    grid: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
      gap: "25px",
      maxWidth: "1200px",
      margin: "0 auto",
    },
    card: {
      background: "#fff",
      borderRadius: "12px",
      boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
      padding: "25px",
      textAlign: "left",
      transition: "all 0.3s ease",
      borderLeft: "8px solid transparent",
      minHeight: "180px",
      cursor: "pointer",
    },
    title: {
      fontSize: "20px",
      fontWeight: "600",
      marginBottom: "15px",
      color: "#1e40af",
    },
    desc: {
      fontSize: "15px",
      lineHeight: "1.6",
      textAlign: "justify",
      color: "#374151",
    },
  };

  return (
    <div style={styles.container}>
      <h2 style={styles.heading}>Benefits of Our Web Development Services</h2>
      <div style={styles.grid}>
        {features.map((feature, index) => (
          <motion.div
            key={index}
            initial={{ ...feature.animation, opacity: 0 }}
            whileInView={{ x: 0, y: 0, opacity: 1 }} // 👈 animation triggers only when in view
            viewport={{ once: true, amount: 0.3 }}   // once:true = animate only first time
            transition={{ duration: 0.8, ease: "easeOut" }}
            style={{
              ...styles.card,
              borderLeft: `8px solid ${feature.color}`,
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.borderLeft = `16px solid ${feature.color}`;
              e.currentTarget.style.transform = "translateY(-5px)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.borderLeft = `8px solid ${feature.color}`;
              e.currentTarget.style.transform = "translateY(0)";
            }}
          >
            <h3 style={styles.title}>{feature.title}</h3>
            <p style={styles.desc}>{feature.description}</p>
          </motion.div>
        ))}
      </div>
    </div>
  );
}

export default Features;
